import React from 'react';

export interface AdminSidebarContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  isAdminRoute: boolean;
}

export const AdminSidebarContext = React.createContext<AdminSidebarContextValue | undefined>(undefined);

export function useAdminSidebar(): AdminSidebarContextValue {
  const context = React.useContext(AdminSidebarContext);
  if (context === undefined) {
    throw new Error('useAdminSidebar must be used within AdminSidebarProvider');
  }
  return context;
}
